module.exports = "/assets/dist/images/bodystyles_suvs_sm.png?18c49f9c0bff5289cc531cec492927d5";